var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "game-help-wrapper" },
    [
      !_vm.isHelpGuide
        ? _vm._l(_vm.helpSource, function (item, index) {
            return _c(
              "div",
              { key: "item" + index },
              [
                item.type === "image"
                  ? _c(
                      "div",
                      { class: [item.class, { "is-mobile": _vm.isMobile }] },
                      [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/images/${item.value}`),
                          },
                        }),
                      ]
                    )
                  : item.type === "link"
                  ? _c("div", {
                      class: item.class,
                      domProps: { innerHTML: _vm._s(item.value) },
                      on: {
                        click: function ($event) {
                          return _vm.toggleTNC(item.link)
                        },
                      },
                    })
                  : item.type === "left-image-template"
                  ? _c("LeftImage", { attrs: { dataSource: item.config } })
                  : _c("div", {
                      class: item.class,
                      domProps: { innerHTML: _vm._s(item.value) },
                    }),
              ],
              1
            )
          })
        : [
            _c(
              "div",
              { staticClass: "help-tabs" },
              _vm._l(_vm.helpTabs, function (tab) {
                return _c(
                  "button",
                  {
                    key: tab.key,
                    class: [
                      "tab-button",
                      { active: _vm.currentTab === tab.key },
                    ],
                    on: {
                      click: function ($event) {
                        _vm.currentTab = tab.key
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t(tab.label)) + " ")]
                )
              }),
              0
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentTab === "ph",
                    expression: "currentTab === 'ph'",
                  },
                ],
              },
              [_c("PhRules")],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentTab === "cam",
                    expression: "currentTab === 'cam'",
                  },
                ],
              },
              [_c("CamRules")],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentTab === "table",
                    expression: "currentTab === 'table'",
                  },
                ],
              },
              [_c("TableTop")],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentTab === "betGuide",
                    expression: "currentTab === 'betGuide'",
                  },
                ],
              },
              [
                _c("BetGuide", {
                  on: {
                    toggleTnc: function ($event) {
                      return _vm.toggleTNC("tnc")
                    },
                  },
                }),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }